const MY_LOAD_LORRY_TABS = {
    LISTING: "listing",
    BIDS: "bids"
};

export { MY_LOAD_LORRY_TABS };
//# sourceMappingURL=tab.js.map
